import GlobalGraphicReportService from '@/services/reports/GlobalGraphicReportService'

export const namespaced = true

export const state = {
    report: {}
}

export const mutations = {
    SET_REPORT(state, report) {
        state.report = report
    }
}

export const actions = {
    fetchGlobalGraphicreport({ commit }, item) {
        GlobalGraphicReportService.getGlobalGraphicReports(item)
            .then(response => {
                commit('SET_REPORT', response.data)
            })
            .catch(error => {
                throw error
            })
    },
    fetchGlobalGraphicFiltredreport({ commit }, item) {
        GlobalGraphicReportService.getGlobalGraphicFiltredReports(item)
            .then(response => {
                commit('SET_REPORT', response.data)
            })
            .catch(error => {
                throw error
            })
    }
}